module.exports = __webpack_public_path__ + "img/4_21.d07c3836.png";